import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const API_URL = `${BASE_URL}/auth`;

const register = (email, password) => {
  return axios.post(API_URL + "/register", {
    email,
    password,
  });
};

const login = (email, password) => {
  // OAuth2 expects application/x-www-form-urlencoded
  const params = new URLSearchParams();
  params.append("username", email);
  params.append("password", password);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  return axios.post(API_URL + "/token", params, config).then((response) => {
    if (response.data.access_token) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  });
};

const logout = () => {
  localStorage.removeItem("user");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const authService = {
  register,
  login,
  logout,
  getCurrentUser,
};

export default authService;
